/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';
import DayStateIcon from './DayStateIcon';
import {
	CONFIRMED,
	CURRENT_CONFIRMED,
	CURRENT_PAUSE,
	CURRENT_PENDING,
	MISSED,
	PAUSE,
	PAUSE_CONFIRMED,
	PENDING,
	TOMORROW,
	CHEATED,
	TOMORROW_PAUSE,
	SUSPICIOUS,
} from './DayStates';
import {translate} from 'react-i18next';
import moment from 'moment';
import DayName from './DayName';
import {getTextColor} from './TextColorHelper';
import {ListItem} from 'material-ui/List';

class SelectableListItem extends React.Component {
	itemSelectable() {
		return [CURRENT_PENDING, TOMORROW].includes(this.props.day.state);
	}
	handleClick() {
		if (this.itemSelectable()) {
			this.props.onPressItem(this.props.day);
		}
	}

	render() {
		const {state} = this.props.day;
		const classes = [];
		if (this.isToday()) {
			classes.push('active');
		}
		if ([CONFIRMED, CURRENT_CONFIRMED, CURRENT_PAUSE].includes(state)) {
			classes.push('success');
		}
		if (![CURRENT_PENDING, TOMORROW].includes(state)) {
			classes.push('notSelectable');
		}
		if ([CURRENT_PENDING].includes(state)) {
			classes.push('success-tbd');
		}

		return (
			<ListItem
				className={`trainingDayWrapper ${classes.join(' ')}`}
				style={{
					borderRadius: 15, // can't target it with css properly.
					boxShadow: this.getShadowForToday(),
					cursor: 'pointer',
				}}
				key={this.props.day._id}
				role={undefined}
				button
				onClick={() => this.handleClick()}
			>
				<DayName position={this.props.day.index} day={this.props.day} isToday={this.isToday()} />

				<div className='trainingDayInfo'>
					<p
						className='trainingDayInfoTitle'
						style={{
							color: getTextColor(this.props.day.state, false),
						}}
					>
						{this.getTitleForDayState()}
					</p>
					<p
						className='trainingDayInfoTime'
						style={{
							color: getTextColor(this.props.day.state, true),
						}}
					>
						{this.getSubtitleForDayState()}
					</p>
				</div>
				<p
					className='trainingDayInfoDate'
					style={{
						color: getTextColor(this.props.day.state, true),
					}}
				>
					{this.getDate()}
				</p>
				<DayStateIcon
					loading={this.props.loading}
					day={this.props.day}
				/>
			</ListItem>
		);
	}

	getShadowForToday() {
		if (this.isToday()) {
			return '0px 16px 32px rgba(0,0,0,.08), 0px 8px 16px rgba(0,0,0,.08)';
		} else {
			return 'none';
		}
	}
	getTitleForDayState() {
		switch (this.props.day.state) {
			case PAUSE_CONFIRMED:
			case TOMORROW_PAUSE:
			case CURRENT_PAUSE:
			case PAUSE:
				return this.props.t('overview:rest_day');
			case TOMORROW:
			case MISSED:
			case CURRENT_CONFIRMED:
			case CONFIRMED:
			case CHEATED:
			case SUSPICIOUS:
			case PENDING:
				return this.props.t('overview:workout');
			case CURRENT_PENDING:
				return this.props.t('overview:workout_today');
			default:
				return '';
		}
	}

	getSubtitleForDayState() {
		switch (this.props.day.state) {
			case PAUSE_CONFIRMED:
				return this.props.t('overview:done');
			case TOMORROW_PAUSE:
				return this.props.t('overview:tomorrow');
			case TOMORROW:
				return this.props.t('overview:tomorrow');
			case CURRENT_PAUSE:
				return this.props.t('overview:done');
			case PAUSE:
				return this.props.t('overview:locked');
			case MISSED:
				if (this.props.day.forgiven) {
					return this.props.t('overview:missed_joker');
				} else {
					return this.props.t('overview:missed');
				}
			case CHEATED:
				return this.props.t('overview:cheated');
			case SUSPICIOUS:
				return this.props.t('overview:suspicious');
			case CURRENT_CONFIRMED:
			case CONFIRMED:
				return this.props.t('overview:done');
			case PENDING:
				return this.props.t('overview:locked');
			case CURRENT_PENDING:
				return this.getTimeLeftString();
			default:
				return '';
		}
	}

	getTimeLeftString() {
		const now = moment(new Date());
		const end = moment(this.props.day.end_deadline);
		const duration = moment.duration(end.diff(now));
		return duration.hours() <= 0
			? this.props.t('common:minute', {count: duration.minutes()})
			: this.props.t('common:hour', {count: duration.hours()});
	}

	isToday() {
		const start = moment(this.props.day.start_deadline);
		return moment(start).isSame(moment(), 'day');
	}

	getDate() {
		if (this.isToday()) {
			return this.props.t('overview:today').toUpperCase();
		} else {
			return moment(this.props.day.start_deadline).format('DD.MM.');
		}
	}
}

export default translate(['overview', 'common'])(SelectableListItem);



// WEBPACK FOOTER //
// ./src/overview/DayListItem.js